export const LOGIN_URL = "admin/login";
export const VERIFY_EMAIL_URL ="admin/verifyEmail"
export const UPDATE_PASSWORD_URL = "admin/forgotPassword"
export const CHANGE_PASSWORD_URL = "admin/resetPassword"
export const LIST_OF_ENQUIRY_URL = "omphalos/admin/listOfInquiries"
export const UPDATE_INQUIRY_URL="omphalos/admin/updateInquiryStatus/"
export const REQUEST_ADD_PRODUCT_URL = "omphalos/product/addProduct"
export const FILE_UPLOAD_URL = "common/fileUpload"
export const LIST_OF_PRODUCTS_URL = "omphalos/product/listOfProduct"
export const EDIT_PRODUCT_URL="omphalos/product/editProduct/"
export const DELETE_PRODUCT_URL="omphalos/product/deleteProduct/"
export const VIEW_PRODUCT_URL="omphalos/customer/viewProduct/"
export const LIST_OF_SERVICES_URL = "omphalos/service/listOfService"   
export const VIEW_SERVICE_URL="omphalos/customer/viewService/"
export const DELETE_SERVICES_URL = "omphalos/service/deleteService/"
export const ADD_SERVICE_URL = "omphalos/service/addService"
export const UPDATE_SERVICE_URL = "omphalos/service/editService/"
export const LIST_OF_MEMBERS_URL = "leadership/omphalos/admin/listOfMembers"   
export const ADD_MEMBERS_URL = "leadership/omphalos/admin/addMembers"
export const UPDATE_MEMBERS_URL = "leadership/omphalos/admin/editMember/"
export const VIEW_MEMBERS_URL="leadership/omphalos/admin/viewMember/"
export const DELETE_MEMBERS_URL = "leadership/omphalos/admin/deleteMember/"
